export default function debounce(func) {
    let timeoutId;
    return (delay,...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
}